export default __webpack_public_path__ + "static/media/flag-pl.0fa9386a.svg";